// Présentation uniquement : aucune conversion implicite, règle clinique ou mesure par défaut.
export function nombreDecimal(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null
    if (typeof value !== 'string' || !/^[+-]?(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(value.trim())) return null
    const result = Number(value.trim().replace(',', '.'))
    return Number.isFinite(result) ? result : null
}

const borneValide = value => value === null || (typeof value === 'string' && /^-?\d{1,12}(?:[.,]\d{1,8})?$/.test(value.trim()))
const comparer = (left, right) => {
    const parts = value => {
        const negative = value.trim().charAt(0) === '-'
        const digits = value.trim().replace(',', '.').replace(/^-/, '').split('.')
        const canonical = digits[0].padStart(12, '0') + (digits[1] || '').padEnd(8, '0')
        return { negative: negative && /[1-9]/.test(canonical), canonical }
    }
    const a = parts(left), b = parts(right)
    if (a.negative !== b.negative) return a.negative ? -1 : 1
    const result = a.canonical === b.canonical ? 0 : a.canonical < b.canonical ? -1 : 1
    return a.negative ? -result : result
}

export function validerIntervalles(field) {
    const errors = [], groups = {}, ids = new Set()
    ;(field.intervals || []).forEach((rule, index) => {
        const lower = rule.lower, upper = rule.upper
        if (!rule.id || ids.has(rule.id)) errors.push('Chaque intervalle doit avoir un identifiant distinct.')
        ids.add(rule.id)
        if (!String(rule.label || '').trim() || !rule.unit || !rule.profile
            || ['neutral', 'green', 'amber', 'red', 'blue'].indexOf(rule.tone) < 0
            || !borneValide(lower) || !borneValide(upper)
            || typeof rule.lower_inclusive !== 'boolean' || typeof rule.upper_inclusive !== 'boolean'
            || (lower === null && rule.lower_inclusive) || (upper === null && rule.upper_inclusive)
            || (lower !== null && upper !== null && (comparer(lower, upper) > 0 || (comparer(lower, upper) === 0 && !(rule.lower_inclusive && rule.upper_inclusive))))) {
            errors.push('Intervalle ' + (index + 1) + ' : renseignez des bornes cohérentes et un message.')
            return
        }
        const key = JSON.stringify([rule.unit, rule.profile])
        if (!groups[key]) groups[key] = []
        groups[key].push({ lower, upper, lower_inclusive: rule.lower_inclusive, upper_inclusive: rule.upper_inclusive })
    })
    Object.keys(groups).forEach(key => {
        const rules = groups[key].sort((a, b) => a.lower === null ? (b.lower === null ? 0 : -1) : b.lower === null ? 1 : comparer(a.lower, b.lower))
        for (let i = 1; i < rules.length; i++) {
            const before = rules[i - 1], after = rules[i]
            if (before.upper === null || after.lower === null || comparer(before.upper, after.lower) > 0
                || (comparer(before.upper, after.lower) === 0 && before.upper_inclusive && after.lower_inclusive)) {
                errors.push('Deux intervalles se chevauchent dans la même unité et le même contexte.')
            }
        }
    })
    return Array.from(new Set(errors))
}

export function badgeIntervalle(field, value, unit, profile = 'general') {
    const number = nombreDecimal(value)
    if (!field || field.enabled === false || field.show_badge === false || number === null || !Array.isArray(field.intervals)) return null
    const matches = field.intervals.filter(rule => {
        if (rule.unit !== unit || rule.profile !== profile) return false
        const lower = rule.lower === null ? -Infinity : nombreDecimal(rule.lower)
        const upper = rule.upper === null ? Infinity : nombreDecimal(rule.upper)
        return lower !== null && upper !== null && (rule.lower_inclusive ? number >= lower : number > lower)
            && (rule.upper_inclusive ? number <= upper : number < upper)
    })
    return matches.length === 1 ? { label: matches[0].label, tone: matches[0].tone } : null
}
